import { Injectable } from '@angular/core';
import {AppService} from '@app/app.service';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService extends AppService {
    constructor() {
        super();
        this.unreadCount$.next(this.getSettingsByKey('notifyCount') ?? 0);
    }


    className: string = 'NotificationsService';
    url: string = '/notification/front_notification';

    /**
     * Флаг активновсти уведомлений (из прав пользователя)
     */
    notificationFlag: boolean = false;

    /**
     * Флаг поиска
     */
    isSearch: boolean = false;

    /** Количество непрочитанных уведомлений */
    public unreadCount$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

    public set unreadCount(val) {
        this.unreadCount$.next(val);
    }
    /**
     * Флаг поддержания в открытом состоянии меню уведомлений
     */
    public flag = false;
    /**
     * Получение настроек таблицы
     */
    public getTableSettings(data): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/fetch_table_settings', data, this._httpOptions);
    }

    /**
     * Получение данных таблицы
     * @param data данные
     */
    public getLists(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/fetch_table_data', data, this._httpOptions);
    }

    /**
     * Сохранение настроек таблицы
     */
    public saveTableSettings(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/save_table_settings', data, this._httpOptions);
    }

    /**
     * Очистка настроек таблицы
     */
    public clearTableSettings(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/clear_table_settings', data, this._httpOptions);
    }

    /**
     * Удаление записей из таблицы
     * @param data данные
     */
    public remove(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/delete', data, this._httpOptions);
    }

    /**
     * Получение записи
     * @param data данные
     */
    public getItem(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/get_item', data, this._httpOptions);
    }
    /**
     * Сохранение целой записи
     * @param data данные
     */
    public save(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/save', data, this._httpOptions);
    }

    /**
     * Получение количества уведомлений
     */
    public getCount(): Observable<number | string> {
        return this.http.post<number>(this.serverUrl + '/notification/front_notification/count', {}, this._httpOptions);
    }

    /**
     * Отметить одно уведомление как прочитанное
     */
    markAsRead(data): Observable<any> {
        return this.http.post<any>(this.serverUrl + '/notification/front_notification/read', data, this._httpOptions);
    }
    /**
     * Изменение статуса всех уведомлений на "прочитано"
     */
    markAsReadAll(): Observable<any> {
        return this.http.post<any>(this.serverUrl + '/notification/front_notification/read_all', {}, this._httpOptions);
    }
}

